export const buildQuestionKey = (question, fallbackKey) => question.value || fallbackKey;
